<template>
  <card id="evaluations" ref="evaluationref">
    <h2 slot="header" class="card-title">{{$t('reports.evaluations')}}</h2>
    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select class="filter-select mr-2" v-model="filters.regions" multiple collapse-tags placeholder="Filter by regions" clearable @change="handleFilters">
                  <el-option v-for="item in filterOptions.regions" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                </el-select>
                <el-select class="filter-select mr-2" v-model="filters.countries" multiple collapse-tags placeholder="Filter by countries" clearable @change="handleFilters">
                  <el-option v-for="item in filterOptions.countries" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                </el-select>
              </div>
              <base-input>
                <el-input
                  type="text"
                  class="mb-3 search-input"
                  prefix-icon="el-icon-search"
                  placeholder="Search and hit enter"
                  v-model="searchQuery"
                  @keyup.native.enter="getItems(1)"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="evaluations" @sort-change="handleSort">
              <el-table-column
                sortable
                label="# Global rank"
                min-width="50"
                property="rank"
              ></el-table-column>
              <el-table-column
                sortable
                label="Final Mark"
                min-width="50"
                property="final_mark"
              >
              </el-table-column>
              <el-table-column
                sortable
                label="Reference"
                property="application.reference"
                prop="application.reference"
              >
                <div slot-scope="props">
                  <a class="link-text" @click="viewApplication(props.row.application)">{{props.row.application.reference}}</a>
                </div>
              </el-table-column>
              <el-table-column
                label="Title"
                property="application.title"
                prop="application.title"
              ></el-table-column>
              <el-table-column align="right" min-width="150" label="Actions">
                <div slot-scope="props">
                  <base-button
                    class="mb-1"
                    type="info"
                    size="sm"
                    @click="viewEvaluation(props.row.application)"
                  >
                    Consolidate Grid
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
              </p>
            </div>
            <base-pagination
              v-if="evaluations.length"
              @input="getItems"
              class="pagination-no-border"
              v-model="pagination.current_page"
              :per-page="pagination.per_page"
              :total="pagination.total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </card>
</template>
<script>
  import {Table, TableColumn, Select, Option} from 'element-ui';
  import {BasePagination, Modal, GenerateReports} from 'src/components';
  import {ApplicationService, ReportsService} from '@/services';

  export default {
    components: {
      GenerateReports,
      BasePagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Modal
    },
    data() {
      return {
        initialized: false,
        pagination: {},
        sortColumn: undefined,
        sortOrder: undefined,
        perPage: 16,
        searchQuery: undefined,
        propsToSearch: ['reference', 'title', 'user_details.email', 'user_details.name', 'user_details.organisation_legal_name', 'region_details.name', 'countries.name', 'status'],
        evaluations: [],
        filterOptions: [],
        filters: {
          status: undefined,
          countries: [],
          regions: []
        },
        evaluationTypes: [],
        modalEvaluate: {
          visibility: false,
          application: {}
        }
      };
    },
    methods: {
      async getItems(page) {
        let vm = this;
        let page_to_get = page || vm.pagination.current_page;

        let loader = vm.$loading.show();

        await ReportsService.getEvaluations({
          page: page_to_get,
          per_page: vm.perPage,
          search: vm.searchQuery,
          sort_column: vm.sortColumn,
          sort_direction: vm.sortDirection,
          filter_status: vm.filters.status,
          filter_regions: vm.filters.regions,
          filter_countries: vm.filters.countries,
        }).then((response) => {
          vm.pagination = response.data.meta;
          vm.evaluations = response.data.data;
        })

        await vm.getFilters();

        loader.hide();
      },
      async getFilters() {
        let vm = this;
        return await ReportsService.getFilters({
          search: vm.searchQuery,
          filter_regions: vm.filters.regions,
          filter_countries: vm.filters.countries,
        }).then((response) => {
          vm.filterOptions = response.data;
        })
      },
      handleFilters() {
        let vm = this;
        vm.getItems(1);
      },
      handleSort(data) {
        let vm = this;
        let direction = null;
        if (data.order === 'ascending') {
          direction = 'asc';
        } else if (data.order === 'descending') {
          direction = 'desc';
        }
        vm.sortColumn = data.prop;
        vm.sortDirection = direction;
        vm.getItems(1);
      },
      viewEvaluation(application) {
        window.open('/reports/evaluations/grid/' + application.application_id, '_blank');
      },
      viewApplication(application) {
        window.open('/application/fill/' + application.grant_id + '/' + application.application_id, '_blank');
      }
    },
    mounted() {
      let vm = this;
      vm.getItems();
    }
  };
</script>
<style lang="scss" scoped>
  .card-body {
    button {
      margin-left: 1rem;
    }
  }

  button {
    white-space: nowrap;
  }

  .evaluations-list {
    list-style-type: disc !important;
  }
</style>
